import { DEFAULT_GLIDER_CLASSES, BREAKPOINTS } from "./ApplicationConfig";
import Gallery from "./gallery/Gallery";
import Slider from "./slider/Slider";

/**
 * Галерея с главным изображением и слайдером миниатюр (такая есть на карточке товара)
 */
export default function initInlineGallery(selector: string)
{
    document.querySelectorAll(selector).forEach((galleryNode) => {
        let sliderNode = galleryNode.querySelector('.common-slider');
        let groupModeMarker = galleryNode.querySelector('.lazy-slider[data-mode="groups"]');
        let productImagesBreakpoints = {}
        productImagesBreakpoints[BREAKPOINTS.LG] = {perView: 1, hideNavArrows: true, useScrollableDots: true};

        let sliderParams = {
            type: 'slider',
            perView: 4,
            useScrollableDots: false,
            keyboard: false,
            gap: 8,
            rewind: false,
            bound: true,
            hideNavArrows: false,
            classes: DEFAULT_GLIDER_CLASSES,
            breakpoints: productImagesBreakpoints,
        }

        if (groupModeMarker) {
            sliderParams.perView = 1;
            sliderParams.gap = 0;
        }

        new Slider(sliderNode, sliderParams);
        new Gallery(galleryNode.getAttribute('data-gallery-name').trim(), galleryNode);
    });
}
